'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reselect = require('reselect');

var _currentUserSelector = require('../user/currentUserSelector');

var _boardSelector = require('../element/board/boardSelector');

var _currentBoardIdSelector = require('../reducers/currentBoardId/currentBoardIdSelector');

var _gridSizeSelector = require('../utils/grid/gridSizeSelector');

var _socketConnectionSelector = require('../utils/socket/socketConnectionSelector');

var _elementSelector = require('../element/elementSelector');

var _permissionsService = require('../utils/permissions/permissionsService');

var _permissionUtil = require('../../common/permissions/permissionUtil');

var _gridConstants = require('../utils/grid/gridConstants');

// Selectors
var elementFilterSelector = (0, _reselect.createSelector)(function (state, ownProps) {
    return ownProps.location;
}, function (location) {
    var query = location.query;
    if (!Object.keys(query).length) return null;

    var elementFilter = {};

    if (query.filter_after) elementFilter.modifiedAfter = query.filter_after;
    if (query.filter_before) elementFilter.modifiedBefore = query.filter_before;
    if (query.filter_user) elementFilter.modifiedBy = query.filter_user.split(',');
    if (query.filter_ids) elementFilter.ids = query.filter_ids.split(',');

    return elementFilter;
});

// Utils


var getIsDragging = function getIsDragging(state) {
    return state.getIn(['app', 'dragging', 'isDragging']);
};

var isMobileViewSelector = (0, _reselect.createSelector)(_gridSizeSelector.getGridSizeName, function (sizeName) {
    return sizeName === _gridConstants.GRID.MOBILE.name;
});

var getCurrentBoard = (0, _reselect.createSelector)(_elementSelector.getElements, _currentBoardIdSelector.getCurrentBoardId, function (elements, currentBoardId) {
    return elements.get(currentBoardId);
});

var isEditableSelector = (0, _reselect.createSelector)(_elementSelector.getElements, _currentBoardIdSelector.getCurrentBoardId, _currentUserSelector.getCurrentUserId, function (elements, currentBoardId, currentUserId) {
    return (0, _permissionUtil.canWrite)((0, _permissionsService.getUserPermissions)(elements, currentBoardId, currentUserId));
});

var pageTitleSelector = (0, _reselect.createSelector)(getCurrentBoard, function (currentBoard) {
    return currentBoard ? currentBoard.getIn(['content', 'title']) + ' - Milanote' : 'Milanote';
});

var workspaceSelector = (0, _reselect.createStructuredSelector)({
    currentBoard: getCurrentBoard,
    currentBoardId: _currentBoardIdSelector.getCurrentBoardId,
    isCurrentBoardFetched: _boardSelector.getIsCurrentBoardFetched,
    isCurrentBoardFetching: _boardSelector.getIsCurrentBoardFetching,
    isCurrentBoardError: _boardSelector.getIsCurrentBoardError,
    isEditable: isEditableSelector,
    pageTitle: pageTitleSelector,

    documentMode: isMobileViewSelector,
    isMobileView: isMobileViewSelector,
    gridSize: _gridSizeSelector.getGridSize,
    isDragging: getIsDragging,
    elementFilter: elementFilterSelector,

    socketConnected: _socketConnectionSelector.socketConnectedSelector,
    socketConnection: _socketConnectionSelector.getSocketConnection,

    isGuest: _currentUserSelector.isGuestSelector,
    currentUser: _currentUserSelector.getCurrentUser,
    isUserAvailable: _currentUserSelector.isUserAvailableSelector
});

exports.default = workspaceSelector;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/workspaceSelector.js
// module id = 2251
// module chunks = 0